import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { SharedModule } from '../shared/shared.module';
import { PaymentsDataStateService } from './payments-data-state.service';
import { PaymentsDataBuilder } from './payments-data.builder';
import { PaymentsDataDispatcher } from './payments-data.dispatcher';
import { PaymentsDataEffects } from './payments-data.effects';
import { PaymentsDataService } from './payments-data.service';
import { StoreModule } from '@ngrx/store';
import { FEATURE_NAME, reducer } from './payments-data.reducer';
import { PaymentsDataStore } from './payments-data.store';

const components = [];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    EffectsModule.forFeature([PaymentsDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
  declarations: [...components],
  exports: [...components],
})
export class PaymentsDataModule {
  static forRoot(): ModuleWithProviders<PaymentsDataModule> {
    return {
      ngModule: PaymentsDataModule,
      providers: [
        PaymentsDataBuilder,
        PaymentsDataService,
        PaymentsDataStateService,
        PaymentsDataDispatcher,
        PaymentsDataStore,
      ],
    };
  }
}
